import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

async function update(
  axios: AxiosInstance,
  taskId: number,
  priority: number,
): Promise<object> {
  const data = await axios.put(`${config.apiBaseUrl}/op/v1/task/${taskId}/update-priority`, { priority });
  return data;
}

export default function useUpdateTaskPriorityMutation({ taskId }: { taskId: number }) {
  const axios = useAxios();
  const toast = useToast();
  return useMutation({
    mutationKey: ['free-trial'],
    mutationFn: (priority: number) => update(axios, taskId, priority),
    onError: (error: any) => {
      manageErrorResponse(toast, error.response.data);
    },
  });
}
